import React from 'react'
import ReservationCardDetails from './tabs/ReservationCardDetails'
import ReservationCardFolios from './tabs/ReservationCardFolios'
import ReservationCardEmail from './tabs/ReservationCardEmail'
import ReservationCardHousekeeping from './tabs/ReservationCardHousekeeping'
import ReservationCardServiceLogs from './tabs/ReservationCardServiceLogs'
import ReservationCardNotes from './tabs/ReservationCardNotes'

export default class ReservationCardWorkspace extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div>
        <div className="tab-content">
          <ReservationCardDetails {...this.props}  />
          <ReservationCardFolios {...this.props}  />
          {/* <ReservationCardEmail {...this.props}  /> */}
          <ReservationCardHousekeeping {...this.props}  />
          <ReservationCardServiceLogs {...this.props}  />
          <ReservationCardNotes {...this.props}  />
          {/* <ReservationCardHistory {...this.props}  /> */}
        </div>
      </div>
    )
  }

}
